import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { JwtModule } from '@auth0/angular-jwt';
import {
    NgbDateNativeAdapter,
    NgbDateParserFormatter,
} from '@ng-bootstrap/ng-bootstrap';

import { NgbDateNativeParserFormatter } from '../shared/form-elements/components/date-picker/ngb-date-native-parser-formatter';
import { NavigationService } from '../shared/navigation/navigation.service';
import { SharedModule } from '../shared/shared.module';
import { FilterSaveService } from '../shared/table/filter-save.service';
import { CoreRouting } from './core.routing';
import { HttpClientInterceptor } from './interceptors/http-client-interceptor';
import { LandingModule } from './landing/landing.module';
import { LayoutModule } from './layout/layout.module';
import { NeedHelpModule } from './need-help/need-help.module';
import { SpinnerService } from './layout/spinner/spinner.service';
import { MultiFactorAuthModalComponent } from './pages/login/multi-factor-auth-modal/multi-factor-auth-modal.component';
import { WebReleaseNotesComponent } from './pages/web-release-notes/web-release-notes.component';
import { PushNotificationModule } from './push-notification/push-notification.module';
import { GetPasswordComponent } from './security/get-password/get-password.component';
import { WebAuthnService } from './security/multi-factor-auth/web-authn.service';
import { SecurityService } from './security/security.service';
import { SystemMessageService } from './system-message/system-message-service';
import { SystemMessageModule } from './system-message/system-message.module';

export function getToken() {
    if (localStorage.getItem('jwt') !== null) {
        return localStorage.getItem('jwt');
    } else {
        document.cookie =
            'JsonWebToken=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'; //expire the cookie
    }
}

/***
 * Contains application-wide, single use components and services.
 * Imported once (in the AppModule) when the app starts and never imported anywhere else.
 */
@NgModule({
    declarations: [
        ...CoreRouting.declarations,
        MultiFactorAuthModalComponent,
        GetPasswordComponent,
        WebReleaseNotesComponent,
    ],
    exports: [
        ...CoreRouting.exports,
        SharedModule,
        LayoutModule,
        RouterModule,
        SystemMessageModule,
        PushNotificationModule,
        NeedHelpModule,
        BrowserModule,
        LandingModule,
    ],
    imports: [
        ...CoreRouting.imports,
        BrowserModule,
        SystemMessageModule,
        PushNotificationModule,
        LayoutModule,
        SharedModule,
        LandingModule,
        NeedHelpModule,
        JwtModule.forRoot({
            config: {
                allowedDomains: [window.location.host],
                tokenGetter: getToken,
            },
        }),
    ],
    providers: [
        ...CoreRouting.providers,
        SystemMessageService,
        SpinnerService,
        SecurityService,
        WebAuthnService,
        NavigationService,
        FilterSaveService,
        {
            provide: NgbDateParserFormatter,
            useClass: NgbDateNativeParserFormatter,
        },
        NgbDateNativeAdapter,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpClientInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class CoreModule {}
